import defaultsDeep from 'lodash.defaultsdeep';
import setupDirectusApi from 'mixins/composition/DirectusApi';

const CMSData = {
  setup(props, { root }) {
    const directusApiComposition = setupDirectusApi(root.$store);
    const {
      getDirectusContent,
    } = directusApiComposition;
    return {
      getDirectusContent,
    };
  },
  metaInfo() {
    return this.metaData;
  },
  data() {
    return {
      directusContentLoading: false,
    };
  },
  computed: {
    cmsRequestParams() {
      const data = this.cmsParams;
      data.language = this.$store.state.app.currentLanguage;
      return data;
    },
    directusContentMetaFallback() {
      // define "cmsFallback" in template to overwrite/merge "defaultVals"
      // example: SomeTemplate.vue
      //   data() { return { cmsFallback: {title: 'special fallback title'} } }

      const defaultVals = {
        title: process.env.CLIENTNAME,
        canonical: `https://product.${process.env.CLIENTNAME}${this.$router.currentRoute.path}`,
        description: '',
      };
      if (this.cmsFallback) {
        return defaultsDeep(this.cmsFallback, defaultVals);
      }
      return defaultVals;
    },
    directusContentMeta() {
      const metaData = this.directusContent?.json_meta;
      return defaultsDeep(metaData, this.directusContentMetaFallback);
    },
    metaData() {
      const returnObj = {
        title: this.directusContentMeta.title,
        meta: [
          {
            vmid: 'description',
            name: 'description',
            content: this.directusContentMeta.description,
          },
        ],
        link: [
          {
            vmid: 'canonical',
            rel: 'canonical',
            href: this.directusContentMeta.canonical,
          },
        ],
      };

      if (this.additionalMeta?.meta) {
        returnObj.meta.push(...this.additionalMeta.meta);
      }
      if (this.additionalMeta?.link) {
        returnObj.link.push(...this.additionalMeta.link);
      }
      if (this.additionalMeta?.script) {
        returnObj.script = [...this.additionalMeta.script];
      }

      return returnObj;
    },
    directusContent() {
      return this.$store.getters.getDirectusContent(`${this.cmsRequestParams.collection}_${this.cmsRequestParams.pageAlias}_${this.cmsRequestParams.language}`);
    },
    directusError() {
      return this.$store.getters.getSsrHttpStatus !== 200;
    },
  },
  serverPrefetch() {
    return this.getDirectusContent(this.cmsRequestParams)
      .then(() => Promise.resolve());
  },
  mounted() {
    if (!this.directusContent) {
      this.directusContentLoading = true;
      this.getDirectusContent(this.cmsRequestParams).finally(() => {
        this.directusContentLoading = false;
      });
    }
  },
  methods: {
    loadContent() {
      if (!this.directusContent) {
        this.directusContentLoading = true;
        this.getDirectusContent(this.cmsRequestParams).finally(() => {
          this.directusContentLoading = false;
        });
      }
    },
  },
  watch: {
    cmsRequestParams: 'loadContent',
  },
};
export default CMSData;
